import React, {useEffect, useState} from 'react'
import Modal from 'antd/lib/modal/Modal';
import { Button } from 'antd';
function FileViewer(props) {

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const url ="https://cors-anywhere.herokuapp.com/"
  function onDocumentLoadSuccess({numPages}){
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offSet){
    setPageNumber(prevPageNumber => prevPageNumber + offSet);
  }

  function changePageBack(){
    changePage(-1)
  }

  function changePageNext(){
    changePage(+1)
  }
  const [isModalVisible, setIsModalVisible] = useState(true);
  const handleCloseViewHistory = () =>{
        setIsModalVisible(false)
        props.handleCloseViewer(false)
  }
  useEffect(()=>{
    props.closemodal("CloseAll")
  },[])
  console.log(props.file, 'props.file')
  return (
    <Modal title="Preview" width={1000} closeIcon open={isModalVisible}
    footer={[
        <Button key="back" onClick={handleCloseViewHistory}>
            Cancel
        </Button>
  ]}>
    <div className='container-file'>
      <header className='container-file-header'>
        {/* <Document file={url+props.file} onLoadSuccess={onDocumentLoadSuccess}>
          <Page height="600" pageNumber={pageNumber} />
        </Document>
        <p> Page {pageNumber} of {numPages}</p>
        <div className='container-file-buttons'>
        { pageNumber > 1 && 
        <button onClick={changePageBack} className='toogle-buttons'>Previous Page</button>
        }
        {
          pageNumber < numPages &&
          <button onClick={changePageNext} className='toogle-buttons'>Next Page</button>
        }
        </div> */}
      {props.file &&<iframe loading="lazy" width="100%" height="600" src={`https://docs.google.com/gview?url=${props.file}&embedded=true`}></iframe>}
      {/* <iframe width="100%" height="600" frameborder="0" src={`https://docs.google.com/gview?url=${props.file}&embedded=true`}></iframe>
      <iframe width="100%" height="600" frameborder="0" src={`https://docs.google.com/gview?url=${props.file}&embedded=true`}></iframe> */}
      </header>
      {/* <center>
        <div>
          <Document file={url+props.file} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(
              new Array(numPages),
              (el,index) => (
                <Page 
                  key={`page_${index+1}`}
                  pageNumber={index+1}
                />
              )
            )}
          </Document>
        </div>
      </center> */}
    </div>
    </Modal>
  );
}

export default FileViewer;